import React, { useEffect, useState } from "react";

const DynamicTable1 = ({
    columns = [],
    data = [],
    isLoading = false,
    emptyText = "No records found",
    footerTotals = null,
    rowClassName = () => "",
}) => {

    // ✅ Dynamic font state
    const [dynamicFont, setDynamicFont] = useState(14);

  useEffect(() => {
    const updateFont = () => {
      const zoom = Math.round((window.outerWidth / window.innerWidth) * 100);
  
      console.log("Zoom %:", zoom);
  
      let size = 14;
  
      if (zoom <= 67) {
        size = 18; // ~67%
      } else if (zoom <= 75 || zoom <=80) {
        size = 16; // ~75%
      } else {
        size = 12; // 90, 100+
      }
  
      setDynamicFont(size);
    };
  
    updateFont();
    window.addEventListener("resize", updateFont);
  
    return () => window.removeEventListener("resize", updateFont);
  }, []);

    return (
        <div className="w-full">

            {/* ================= DESKTOP TABLE ================= */}
            <div className="hidden md:block rounded-xl border border-gray-600 bg-white shadow-sm max-h-[70vh] overflow-y-auto">

                <table
                    style={{ fontSize: `${dynamicFont}px`, fontWeight: "500" }}
                    className="w-full leading-relaxed border-collapse table-fixed"
                >

                    {/* ================= HEADER ================= */}
                    <thead className="bg-[#0A2A4F] sticky top-0 z-10">
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    style={{  fontSize: `${dynamicFont}px`, fontWeight: "500" }}
                                    className={`
px-2 py-2
text-left
text-white
border border-gray-600

${col.key === "txnId" ? "w-[18%]" : ""}
${col.key === "txnDate" ? "w-[15%]" : ""}
${col.key === "narration" ? "w-[40%]" : ""}

${col.key === "amount_cr" ? "w-[15%]" : ""}
${col.key === "amount_dr" ? "w-[15%]" : ""}

${["charges", "tds", "commission"].includes(col.key) ? "w-[10%]" : ""}

${["txnAmount", "balance"].includes(col.key) ? "w-[15%]" : ""}
`}
                                >
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* ================= BODY ================= */}
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan={columns.length} className="text-center py-10 text-gray-500">
                                    Loading...
                                </td>
                            </tr>
                        ) : data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    className={`
    ${rowClassName(row) || "odd:bg-white even:bg-gray-50"}
    hover:bg-blue-50 transition
  `}
                                >
                                    {columns.map((col) => (
                                        <td
                                            key={col.key}
                                            style={{ fontSize: `${dynamicFont}px`, fontWeight: "600" }}
                                            className={`
                        border border-gray-600
                        px-2 py-2
                        align-top

                      ${col.key === "narration"
                                                    ? "whitespace-normal break-words leading-relaxed text-gray-900 font-semibold"
                                                    : ["txnId", "txnDate"].includes(col.key)
                                                        ? "whitespace-normal break-words text-gray-700"
                                                        : "whitespace-nowrap text-gray-800"
                                                }

                        ${[
                                                    "amount_cr",
                                                    "amount_dr",
                                                    "charges",
                                                    "tds",
                                                    "cashback",
                                                    "commission",
                                                    "txnAmount",
                                                    "balance",
                                                ].includes(col.key)
                                                    ? "text-left whitespace-nowrap tabular-nums font-semibold"
                                                    : ""
                                                }
                      `}
                                        >
                                            {col.render
                                                ? col.render(row[col.key], row)
                                                : row[col.key] ?? "—"}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="text-center py-10 text-gray-500">
                                    {emptyText}
                                </td>
                            </tr>
                        )}
                    </tbody>

                    {/* ================= FOOTER TOTALS ================= */}
                    {footerTotals && data.length > 0 && (
                        <tfoot>
                            <tr
                                style={{ fontSize: `${dynamicFont - 1}px`, fontWeight: "700" }}
                                className="bg-gray-100"
                            >
                                {columns.map((col) => {

                                    if (col.key === "txnId") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2">
                                                TOTAL
                                            </td>
                                        );
                                    }

                                    if (col.key === "amount_cr") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-green-700">
                                                ₹{footerTotals.totalCR?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "amount_dr") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-red-600">
                                                ₹{footerTotals.totalDR?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "amount_rr") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-yellow-700">
                                                ₹{footerTotals.totalRR?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "charges") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-red-700">
                                                ₹{footerTotals.totalCharges?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "tds") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-red-800">
                                                ₹{footerTotals.totalTds?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "netAmount" || col.key === "txnAmount") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-blue-800">
                                                ₹{footerTotals.totalNetAmount?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "cashback") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-green-700">
                                                ₹{footerTotals.totalCashback?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    if (col.key === "commission") {
                                        return (
                                            <td key={col.key} className="border border-gray-300 px-2 py-2 text-left text-green-800">
                                                ₹{footerTotals.totalCommission?.toFixed(2)}
                                            </td>
                                        );
                                    }

                                    return (
                                        <td key={col.key} className="border border-gray-300 px-2 py-2">
                                            —
                                        </td>
                                    );
                                })}
                            </tr>
                        </tfoot>
                    )}

                </table>
            </div>

            {/* ================= MOBILE CARD VIEW ================= */}
            <div className="block md:hidden space-y-4">
                {isLoading ? (
                    <div className="text-center py-10 text-gray-500">
                        Loading...
                    </div>
                ) : data.length > 0 ? (
                    data.map((row, index) => (
                        <div
                            key={index}
                            style={{ fontSize: `${dynamicFont}px`, fontWeight: "600" }}
                            className="rounded-xl border border-gray-300 bg-white p-4 shadow-sm"
                        >
                            {columns.map((col) => (
                                <div
                                    key={col.key}
                                    className="flex justify-between gap-4 py-2 border-b border-gray-200 last:border-b-0"
                                >
                                    <span className="font-semibold text-gray-500">
                                        {col.label}
                                    </span>

                                    <span className="font-bold text-gray-800 text-right break-words">
                                        {col.render
                                            ? col.render(row[col.key], row)
                                            : row[col.key] ?? "—"}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))
                ) : (
                    <div className="text-center py-10 text-gray-500">
                        {emptyText}
                    </div>
                )}
            </div>

        </div>
    );
};

export default DynamicTable1;